/** Dictionnaire source (français). Les autres langues doivent fournir exactement les mêmes clés. */
import { fleetFr } from '../../features/fleet/locales';
import { peopleFr } from '../../features/people/locales';
import { deploymentFr } from '../../features/deployment/i18n';
import { billingFr } from '../../features/billing/i18n';
import { settingsFr } from '../../features/settings/i18n';
import { satisfactionFr } from '../../features/satisfaction/locales';

export const fr = {
  'common.error': 'Une erreur est survenue',
  'common.errorDescription': 'Impossible de charger les données. Vérifiez votre connexion puis réessayez.',
  'common.retry': 'Réessayer',
  'common.date': 'Date',

  'ui.close': 'Fermer',
  'ui.clear': 'Effacer',
  'ui.notifications': 'Notifications',
  'ui.table.selectAll': 'Tout sélectionner',
  'ui.table.selectRow': 'Sélectionner la ligne',
  'ui.table.empty': 'Aucun résultat',
  'ui.table.selected': '{count} sélectionné(s)',
  'ui.table.total': '{count} élément(s)',
  'ui.table.pagination': 'Pagination',
  'ui.table.prev': 'Page précédente',
  'ui.table.next': 'Page suivante',
  'ui.table.page': 'Page {page} sur {count}',

  'status.online': 'En ligne',
  'status.offline': 'Hors ligne',

  'nav.dashboard': 'Tableau de bord',
  'nav.fleet': 'Parc',
  'nav.people': 'Personnes',
  'nav.policies': 'Politiques',
  'nav.audit': 'Audit & sessions',
  'nav.satisfaction': 'Satisfaction',
  'nav.deployment': 'Déploiement',
  'nav.billing': 'Facturation',
  'nav.settings': 'Paramètres',

  'shell.skipToContent': 'Aller au contenu',
  'shell.navigation': 'Navigation principale',
  'shell.collapse': 'Réduire le menu',
  'shell.expand': 'Déplier le menu',
  'shell.openMenu': 'Ouvrir le menu',
  'shell.language': 'Langue',
  'shell.themeDark': 'Passer au thème sombre',
  'shell.themeLight': 'Passer au thème clair',
  'shell.userMenu': 'Menu utilisateur',
  'shell.profile': 'Mon profil',
  'shell.logout': 'Se déconnecter',

  'org.current': 'Organisation active',
  'org.switch': 'Changer d\'organisation',

  'search.placeholder': 'Rechercher un appareil, une page…',
  'search.results': 'Résultats de recherche',
  'search.none': 'Aucun résultat',
  'search.page': 'Page',

  'forbidden.title': 'Accès refusé',
  'forbidden.description': 'Votre rôle ne vous permet pas d\'accéder à cette zone. Contactez un administrateur de l\'organisation.',

  'placeholder.eyebrow': 'Bientôt disponible',
  'placeholder.title': 'Cet écran est en cours de développement',
  'placeholder.description': 'La structure, la navigation et les permissions sont en place. Écrans prévus pour cette zone :',
  'placeholder.planned': 'Écrans prévus',

  'zone.fleet.title': 'Parc',
  'zone.fleet.description': 'Appareils de l\'organisation, état en ligne, groupes et inventaire.',
  'zone.fleet.screens': 'Liste et arbre des appareils|Fiche appareil|Groupes et étiquettes|Inventaire|Alertes|Actions (déployer, mettre à jour, révoquer)',
  'zone.people.title': 'Personnes',
  'zone.people.description': 'Techniciens, rôles, invitations et sécurité des accès.',
  'zone.people.screens': 'Utilisateurs|Rôles et permissions|Invitations|SSO|Appareils de confiance|Blocage IP / pays',
  'zone.policies.title': 'Politiques',
  'zone.policies.description': 'Règles d\'administration appliquées aux agents.',
  'zone.policies.screens': 'Modèles de politique|Affectation par groupe / rôle|Aperçu de l\'effet|Mode test',
  'zone.audit.title': 'Audit & sessions',
  'zone.audit.description': 'Journal d\'audit, historique des sessions et enregistrements.',
  'zone.audit.screens': 'Journal filtrable|Détail d\'une session|Enregistrements|Export CSV / JSON',
  'zone.deployment.title': 'Déploiement',
  'zone.deployment.description': 'Enrôlement de masse et mises à jour des agents.',
  'zone.deployment.screens': 'Paquets MSI / PKG|Jetons d\'enrôlement|Canaux stable / bêta|Versions et progression',
  'zone.billing.title': 'Facturation',
  'zone.billing.description': 'Abonnement, utilisation et factures.',
  'zone.billing.screens': 'Plan|Utilisation|Factures|Moyen de paiement|Essai gratuit',
  'zone.settings.title': 'Paramètres',
  'zone.settings.description': 'Organisation, marque blanche, intégrations et clés d\'API.',
  'zone.settings.screens': 'Organisation et domaine|Marque blanche|Intégrations|Clés d\'API',

  'login.title': 'Connexion',
  'login.subtitle': 'Accédez à la console d\'administration de votre organisation.',
  'login.email': 'Adresse e-mail',
  'login.password': 'Mot de passe',
  'login.submit': 'Se connecter',
  'login.error.credentials': 'Adresse e-mail ou mot de passe incorrect.',
  'login.error.totp': 'Code de vérification invalide.',
  'login.error.expired': 'La vérification a expiré. Reconnectez-vous.',
  'login.error.noOrg': 'Ce compte n\'est rattaché à aucune organisation.',
  'login.error.generic': 'Connexion impossible pour le moment. Réessayez.',
  'login.hero.title': 'Pilotez votre parc.',
  'login.hero.accent': 'En toute maîtrise.',
  'login.hero.text': 'Qui peut se connecter à quoi, depuis où, avec quelles limites, et pour quel coût : tout se règle ici.',
  'login.hero.p1': 'Appareils, groupes et état en temps réel',
  'login.hero.p2': 'Rôles, politiques et journal d\'audit',
  'login.hero.p3': 'Déploiement de masse et facturation',
  'login.totp.title': 'Vérification en deux étapes',
  'login.totp.subtitle': 'Saisissez le code à 6 chiffres de votre application d\'authentification pour {email}.',
  'login.totp.code': 'Code de vérification',
  'login.totp.submit': 'Vérifier',
  'login.totp.back': 'Retour',
  'login.totp.demoHint': 'Démo : le code est 123456.',
  'login.demo.title': 'Mode démonstration',
  'login.demo.hint': 'Données simulées. Mot de passe : siraj-demo. Cliquez pour remplir.',
  'login.demo.owner': 'Propriétaire',
  'login.demo.supervisor': 'Superviseur',
  'login.demo.technician': 'Technicien',
  'login.demo.billing': 'Facturation',
  'login.noAccount': 'Pas encore de compte ?',
  'login.createAccount': 'Créer un compte',

  'register.title': 'Créer votre console',
  'register.subtitle': 'Inscrivez votre organisation et devenez son propriétaire.',
  'register.name': 'Votre nom',
  'register.email': 'Adresse e-mail',
  'register.password': 'Mot de passe',
  'register.passwordHint': '8 caractères minimum.',
  'register.orgName': 'Nom de l\'organisation',
  'register.submit': 'Créer le compte',
  'register.hasAccount': 'Déjà un compte ?',
  'register.signIn': 'Se connecter',
  'register.error.emailTaken': 'Cette adresse e-mail est déjà utilisée.',
  'register.error.generic': 'Inscription impossible pour le moment. Réessayez.',

  'choosePlan.title': 'Choisir une offre',
  'choosePlan.subtitle': 'Pour utiliser la Console de {org}, démarrez l\'essai PRO ou souscrivez à une offre payante.',
  'choosePlan.trial.title': 'Essai PRO de 15 jours',
  'choosePlan.trial.desc': 'Toutes les fonctions du plan Pro pendant 15 jours, sans engagement. L\'essai n\'est disponible qu\'une fois par organisation.',
  'choosePlan.trial.used': 'L\'essai de cette organisation est terminé. Choisissez une offre payante pour continuer.',
  'choosePlan.trial.cta': 'Démarrer l\'essai',
  'choosePlan.trial.done': 'Essai PRO démarré pour 15 jours',
  'choosePlan.plan.pro': 'Pour les petites équipes de support.',
  'choosePlan.plan.team': 'Pour les équipes qui gèrent un parc important.',
  'choosePlan.plan.enterprise': 'Pour les grandes organisations, sur devis.',
  'choosePlan.paid.cta': 'S\'abonner',
  'choosePlan.paid.choose': 'S\'abonner au plan {plan}',
  'choosePlan.paid.done': 'Plan {plan} activé',
  'choosePlan.notAllowed': 'Seul le propriétaire ou le responsable de la facturation peut choisir une offre. Contactez-le pour ouvrir la Console.',
  'choosePlan.freeNote': 'Sans offre, la Console reste fermée. Remote reste disponible avec les limites de l\'offre gratuite.',
  'choosePlan.switchOrg': 'Changer d\'organisation',
  'choosePlan.error': 'Action impossible',
  'choosePlan.error.conflict': 'Action impossible : l\'essai a déjà été utilisé ou une offre est déjà souscrite',
  'invitation.accept.pending': "Acceptation de l'invitation…",
  'invitation.accept.done': 'Invitation acceptée. Redirection…',
  'invitation.accept.error': "Cette invitation est invalide, expirée ou adressée à un autre compte. Connectez-vous avec l'adresse e-mail invitée.",
  'invitation.accept.retry': 'Réessayer',
  'selectOrg.title': 'Choisissez une organisation',
  'selectOrg.subtitle': 'Bonjour {name}, quelle organisation souhaitez-vous administrer ?',

  'dashboard.greeting': 'Bonjour {name}',
  'dashboard.subtitle': 'Voici l\'état de votre parc et de votre service aujourd\'hui.',
  'dashboard.kpis': 'Indicateurs clés',
  'dashboard.devicesOnline': 'Appareils en ligne',
  'dashboard.devicesOnlineHint': '{pct} % du parc',
  'dashboard.sessionsToday': 'Sessions du jour',
  'dashboard.vsYesterday': 'vs hier',
  'dashboard.activeSessions': 'Sessions en cours',
  'dashboard.activeSessionsHint': 'en ce moment',
  'dashboard.alerts': 'Alertes ouvertes',
  'dashboard.alertsHint': 'dont {count} critique(s)',
  'dashboard.activity': 'Activité sur 7 jours',
  'dashboard.activityDesc': 'Sessions à distance par jour',
  'dashboard.activityAria': 'Histogramme : {total} sessions sur les 7 derniers jours',
  'dashboard.sessions': 'Sessions',
  'dashboard.devicesTouched': 'Appareils distincts',
  'dashboard.usage': 'Consommation',
  'dashboard.usageDesc': 'Licences et crédits IA de la période',
  'dashboard.technicians': 'Techniciens',
  'dashboard.aiCredits': 'Crédits IA',
  'dashboard.devices': 'Appareils',
  'dashboard.unlimited': 'illimité',
  'dashboard.alertsTitle': 'Alertes à traiter',
  'dashboard.alertsDesc': 'Disque, mémoire, appareils hors ligne, agents obsolètes',
  'dashboard.noAlerts': 'Aucune alerte : tout est en ordre',
  'dashboard.service': 'État du service',
  'dashboard.serviceDesc': 'Composants Siraj',
  'dashboard.updatedAt': 'Mis à jour à {time}',

  'severity.critical': 'Critique',
  'severity.warning': 'Attention',
  'severity.info': 'Info',
  'alert.offline': 'Hors ligne depuis {value} jour(s)',
  'alert.disk': 'Disque plein à {value} %',
  'alert.ram': 'Mémoire utilisée à {value} %',
  'alert.agent_outdated': 'Agent Siraj obsolète',
  'alert.policy_denied': 'Accès refusé par une politique',

  'service.relay': 'Relais',
  'service.rendezvous': 'Rendez-vous',
  'service.api': 'API',
  'service.ai': 'Assistant IA',
  'service.status.operational': 'Opérationnel',
  'service.status.degraded': 'Dégradé',
  'service.status.outage': 'Panne',
  // >>> zone policies
  'policies.title': 'Modèles de politique',
  'policies.subtitle': 'Règles d\'administration appliquées aux agents : plafonds de qualité, transferts, confidentialité, horaires.',
  'policies.new': 'Nouvelle politique',
  'policies.newDesc': 'Créée en brouillon, en mode test : rien n\'est appliqué avant votre validation.',
  'policies.name': 'Nom',
  'policies.description': 'Description',
  'policies.status': 'Statut',
  'policies.status.active': 'Actif',
  'policies.status.draft': 'Brouillon',
  'policies.version': 'Version',
  'policies.targets': 'Cibles',
  'policies.targetsAll': 'Tout le parc',
  'policies.targetsCount': '{count} cible(s)',
  'policies.updated': 'Modifiée',
  'policies.actions': 'Actions',
  'policies.default': 'Par défaut',
  'policies.dryRun': 'Mode test',
  'policies.empty': 'Aucune politique pour le moment.',
  'policies.cancel': 'Annuler',
  'policies.noDefault': 'Aucune politique par défaut',
  'policies.noDefaultDesc': 'Sans cible, une politique vaut pour tout le parc. Créez une politique par défaut permissive (aucune restriction) pour partir d\'une base saine.',
  'policies.createDefault': 'Créer la politique par défaut permissive',
  'policies.defaultName': 'Politique par défaut',
  'policies.defaultDesc': 'Permissive : appliquée à tous les appareils sans politique spécifique.',
  'policies.defaultCreated': 'Politique par défaut créée',
  'policies.delete': 'Supprimer {name}',
  'policies.deleteTitle': 'Supprimer « {name} » ?',
  'policies.deleteDesc': 'Les agents concernés reviennent à la politique par défaut. L\'historique des versions est conservé dans le journal d\'audit.',
  'policies.apply.needName': "Le nom de la politique est requis pour l'appliquer.",
  'policies.apply.noChanges': "Aucune modification à appliquer : modifiez la politique d'abord.",
  'policies.deleteDescDefault': "Cette politique par défaut s'applique à tous les agents : sa suppression les ramène aux réglages du système.",
  'policies.deleteConfirm': 'Supprimer',
  'policies.deleted': 'Politique supprimée',
  'policies.deleteError': 'Suppression impossible',
  'policies.notFound': 'Politique introuvable',
  'policies.backToList': 'Toutes les politiques',
  'policies.editorSubtitle': 'Version {version} · chaque modification crée une nouvelle version',
  'policies.general': 'Général',
  'policies.dryRunLabel': 'Mode test (dry-run)',
  'policies.dryRunDesc': 'Les agents journalisent ce qui serait bloqué sans rien appliquer. Recommandé avant toute restriction.',
  'policies.tabs': 'Sections de la politique',
  'policies.tab.rules': 'Règles',
  'policies.tab.assign': 'Affectation et aperçu',
  'policies.tab.history': 'Historique',
  'policies.tab.delivery': 'Diffusion',
  'policies.saveDraft': 'Enregistrer le brouillon',
  'policies.apply': 'Appliquer…',
  'policies.applyChanges': 'Appliquer les modifications…',
  'policies.backToDraft': 'Repasser en brouillon',
  'policies.resetPermissive': 'Revenir aux règles permissives',
  'policies.saved': 'Brouillon enregistré',
  'policies.applied': 'Politique appliquée : diffusion en cours',
  'policies.reverted': 'Politique repassée en brouillon',
  'policies.saveError': 'Enregistrement impossible. Réessayez.',
  'error.featureUnavailable': 'Cette fonctionnalité n\'est pas incluse dans votre plan actuel. Passez à un plan supérieur pour l\'utiliser.',
  'error.quotaExceeded': 'Vous avez atteint la limite de votre plan. Passez à un plan supérieur pour l\'augmenter.',
  'error.upgradeLink': 'Voir les plans',
  'error.invalidResponse': 'Réponse inattendue du serveur. Réessayez dans un instant.',
  'policies.forbidden': 'Vous n\'avez pas la permission de modifier les politiques.',
  'policies.rules.emptyUnlimited': 'Vide = illimité',
  'policies.rules.transfers': 'Transferts et presse-papiers',
  'policies.rules.transfersDesc': 'Types de fichiers bloqués, taille maximale et sens du copier-coller.',
  'policies.rules.privacy': 'Confidentialité et contrôle',
  'policies.rules.privacyDesc': 'Écran de confidentialité, enregistrement et approbation par un responsable.',
  'policies.rules.windows': 'Fenêtres horaires d\'accès',
  'policies.rules.windowsDesc': 'S\'appliquent aux cibles de la politique (techniciens, rôles, groupes). Hors fenêtre, l\'accès est refusé.',
  'policies.rule.blockedFileTypes': 'Types de fichiers bloqués',
  'policies.rule.blockedFileTypesHint': 'Extensions séparées par des virgules',
  'policies.rule.maxTransferMb': 'Taille maximale par transfert (Mo)',
  'policies.rule.clipboard': 'Presse-papiers',
  'policies.rule.privacyScreen': 'Écran de confidentialité',
  'policies.rule.privacyScreenDesc': 'Masque l\'écran de l\'appareil pendant la session.',
  'policies.rule.recordingRequired': 'Enregistrement obligatoire',
  'policies.rule.recordingRequiredDesc': 'Toute session est enregistrée (avec rétention et chiffrement).',
  'policies.rule.requireApproval': 'Approbation par un responsable',
  'policies.rule.requireApprovalDesc': 'Une connexion sensible attend l\'accord d\'un responsable.',
  'policies.rule.approverRole': 'Rôle approbateur',
  'policies.rule.approverNone': 'Choisir un rôle',
  'policies.rule.approverRoleId': 'Rôle approbateur',
  'policies.rule.accessWindows': 'Fenêtres horaires',
  'policies.rule.targets': 'Affectation',
  'policies.rule.enabled': 'Statut',
  'policies.rule.dryRun': 'Mode test',
  'policies.clipboard.both': 'Dans les deux sens',
  'policies.clipboard.to_host': 'Vers l\'appareil seulement',
  'policies.clipboard.from_host': 'Depuis l\'appareil seulement',
  'policies.clipboard.none': 'Bloqué',
  'policies.window.add': 'Ajouter une fenêtre',
  'policies.window.none': 'Aucune fenêtre : accès autorisé à toute heure.',
  'policies.window.days': 'Jours',
  'policies.window.start': 'Début',
  'policies.window.end': 'Fin',
  'policies.window.remove': 'Supprimer la fenêtre',
  'policies.day.0': 'Dim',
  'policies.day.1': 'Lun',
  'policies.day.2': 'Mar',
  'policies.day.3': 'Mer',
  'policies.day.4': 'Jeu',
  'policies.day.5': 'Ven',
  'policies.day.6': 'Sam',
  'policies.assign.title': 'Affectation',
  'policies.assign.desc': 'Par groupe, rôle, technicien ou appareil. Sans aucune cible, la politique vaut pour tout le parc.',
  'policies.assign.groups': 'Groupes d\'appareils',
  'policies.assign.noGroups': 'Aucun groupe',
  'policies.assign.roles': 'Rôles',
  'policies.assign.members': 'Techniciens',
  'policies.assign.devices': 'Appareils',
  'policies.assign.searchMembers': 'Rechercher un technicien',
  'policies.assign.searchDevices': 'Rechercher un appareil',
  'policies.assign.selectedDevices': 'Appareils sélectionnés',
  'policies.preview.title': 'Aperçu de l\'effet',
  'policies.preview.desc': 'Estime les appareils et utilisateurs touchés et détecte les conflits avant toute application.',
  'policies.preview.run': 'Calculer l\'aperçu',
  'policies.preview.devices': 'Appareils touchés',
  'policies.preview.members': 'Utilisateurs touchés',
  'policies.preview.conflicts': 'Conflits',
  'policies.preview.conflict': 'Chevauche « {name} » sur {count} appareil(s) : la règle la plus restrictive l\'emporte.',
  'policies.preview.dryRunNote': 'Mode test : aucun blocage réel, les agents journalisent seulement.',
  'policies.preview.error': 'Aperçu indisponible. Vous pouvez réessayer.',
  'policies.warn.access_windows': 'Des fenêtres horaires refuseront l\'accès en dehors des plages définies.',
  'policies.warn.no_approver': 'Aucun membre n\'a le rôle approbateur : les connexions sensibles resteraient bloquées.',
  'policies.warn.clipboard_none': 'Le presse-papiers est bloqué dans les deux sens.',
  'policies.warn.no_target': 'Aucun appareil n\'est visé par cette affectation.',
  'policies.risk.title': 'Risques de verrouillage',
  'policies.risk.windows_invalid': 'Une fenêtre horaire a une fin qui précède son début ou égale son début.',
  'policies.risk.windows_no_days': 'Une fenêtre horaire n\'a aucun jour : elle n\'autorise jamais l\'accès.',
  'policies.risk.windows_narrow': 'Les fenêtres couvrent moins de 20 h par semaine : l\'accès sera très restreint.',
  'policies.risk.approval_no_approver': 'L\'approbation est exigée sans rôle approbateur : personne ne pourra valider.',
  'policies.risk.global_restrictive': 'Cette politique restrictive vise tout le parc, y compris les administrateurs.',
  'policies.risk.ack': 'Je comprends le risque de verrouillage et souhaite appliquer quand même.',
  'policies.apply.title': 'Appliquer la politique ?',
  'policies.apply.titleDryRun': 'Activer en mode test ?',
  'policies.apply.desc': 'Vérifiez l\'effet attendu. La nouvelle version sera diffusée aux agents en ligne.',
  'policies.apply.confirm': 'Appliquer maintenant',
  'policies.apply.confirmDryRun': 'Activer en mode test',
  'policies.history.title': 'Historique des versions',
  'policies.history.desc': 'Chaque modification est conservée. Un retour arrière crée une nouvelle version.',
  'policies.history.empty': 'Aucune version',
  'policies.history.current': 'Version courante',
  'policies.history.changed': 'Modifié :',
  'policies.history.rollbackOf': 'Retour arrière vers la v{version}',
  'policies.history.rollback': 'Revenir à la v{version}',
  'policies.history.rollbackTitle': 'Revenir à la version {version} ?',
  'policies.history.rollbackDesc': 'Les règles et l\'affectation de la v{version} seront restaurées sous la forme d\'une nouvelle version v{next}, diffusée aux agents.',
  'policies.history.rollbackConfirm': 'Revenir en arrière',
  'policies.history.rolledBack': 'Version {version} restaurée',
  'policies.history.rollbackError': 'Retour arrière impossible',
  'policies.delivery.title': 'Diffusion aux agents',
  'policies.delivery.desc': 'Accusé de réception de chaque agent pour la version courante.',
  'policies.delivery.dryRunDesc': 'Mode test : les agents accusent réception mais ne bloquent rien.',
  'policies.delivery.none': 'Aucune diffusion',
  'policies.delivery.noneDesc': 'Un brouillon n\'est diffusé à aucun agent. Appliquez la politique pour la déployer.',
  'policies.delivery.progress': '{done} / {total} agents ont accusé réception ({pct} %)',
  'policies.delivery.device': 'Appareil',
  'policies.delivery.status': 'État',
  'policies.delivery.ackedAt': 'Accusé le',
  'policies.delivery.acknowledged': 'Reçu',
  'policies.delivery.pending': 'En attente',
  'policies.delivery.offline': 'Hors ligne',
  'policies.delivery.failed': 'Échec',
  // <<< zone policies
  // >>> zone fleet
  ...fleetFr,
  // <<< zone fleet
  // >>> zone people
  ...peopleFr,
  // <<< zone people
  // >>> zone deployment
  ...deploymentFr,
  // <<< zone deployment
  // >>> zone billing
  ...billingFr,
  // <<< zone billing
  // >>> zone audit
  'audit.title': 'Audit & sessions',
  'audit.subtitle': 'Journal d\'audit signé, historique des sessions, enregistrements et rapports de conformité.',
  'audit.tabs': 'Sections audit et sessions',
  'audit.tab.journal': 'Journal d\'audit',
  'audit.tab.sessions': 'Sessions',
  'audit.tab.compliance': 'Conformité',
  'audit.cancel': 'Annuler',
  'audit.journal': 'Journal d\'audit',
  'audit.search': 'Rechercher (acteur, action, cible, IP)',
  'audit.count': '{count} événement(s)',
  'audit.loading': 'Chargement…',
  'audit.empty': 'Aucun événement ne correspond aux filtres.',
  'audit.filter.action': 'Action',
  'audit.filter.actor': 'Acteur',
  'audit.filter.outcome': 'Résultat',
  'audit.filter.device': 'Appareil',
  'audit.filter.devicePlaceholder': 'Nom de l\'appareil',
  'audit.filter.signature': 'Signature',
  'audit.filter.from': 'Du',
  'audit.filter.to': 'Au',
  'audit.filter.all': 'Tous',
  'audit.filter.reset': 'Réinitialiser les filtres',
  'audit.col.time': 'Date',
  'audit.col.actor': 'Acteur',
  'audit.col.action': 'Action',
  'audit.col.target': 'Cible',
  'audit.col.outcome': 'Résultat',
  'audit.col.signature': 'Signature',
  'audit.outcome.success': 'Succès',
  'audit.outcome.failure': 'Échec',
  'audit.outcome.denied': 'Refusé',
  'audit.actorType.member': 'membre',
  'audit.actorType.device': 'appareil',
  'audit.actorType.system': 'système',
  'audit.actorType.api': 'API',
  'audit.signature.valid': 'Signature vérifiée',
  'audit.signature.invalid': 'Signature invalide',
  'audit.signature.validDesc': 'Le chaînage de hash est intact : l\'événement n\'a pas été modifié depuis son enregistrement.',
  'audit.signature.invalidDesc': 'Le chaînage de hash ne correspond pas : l\'événement a pu être altéré ou perdu. Contactez le support Siraj et conservez une copie du JSON.',
  'audit.event.title': 'Détail de l\'événement',
  'audit.event.open': 'Ouvrir l\'événement {action}',
  'audit.event.origin': 'Origine',
  'audit.event.json': 'Événement brut (JSON)',
  'audit.event.copy': 'Copier le JSON',
  'audit.event.copied': 'JSON copié',
  'audit.event.copyError': 'Copie impossible',
  'audit.export.button': 'Exporter',
  'audit.export.csv': 'Exporter en CSV',
  'audit.export.json': 'Exporter en JSON',
  'audit.export.done': 'Export téléchargé : {filename}',
  'audit.export.error': 'Export impossible',
  'audit.session.title': 'Détail de la session',
  'audit.session.search': 'Rechercher (appareil, technicien, ticket)',
  'audit.session.count': '{count} session(s)',
  'audit.session.empty': 'Aucune session ne correspond aux filtres.',
  'audit.session.open': 'Ouvrir la session sur {device}',
  'audit.session.start': 'Début',
  'audit.session.end': 'Fin',
  'audit.session.ongoing': 'en cours',
  'audit.session.duration': 'Durée',
  'audit.session.technician': 'Technicien',
  'audit.session.device': 'Appareil',
  'audit.session.deletedDevice': 'Appareil supprimé',
  'audit.session.modeCol': 'Mode',
  'audit.session.statusCol': 'Statut',
  'audit.session.recording': 'Enregistrement',
  'audit.session.recorded': 'Enregistrée',
  'audit.session.ticketCol': 'Ticket',
  'audit.session.actions': 'Actions effectuées',
  'audit.session.transferred': 'Données transférées',
  'audit.session.mode.attended': 'Avec utilisateur',
  'audit.session.mode.unattended': 'Sans surveillance',
  'audit.session.status.active': 'En cours',
  'audit.session.status.ended': 'Terminée',
  'audit.session.status.failed': 'Échec',
  'audit.session.participants': 'Participants',
  'audit.session.role.technician': 'technicien',
  'audit.session.role.client': 'client',
  'audit.session.role.observer': 'observateur',
  'audit.session.summary': 'Résumé IA',
  'audit.session.noSummary': 'Aucun résumé disponible.',
  'audit.session.rating': 'Évaluation client',
  'audit.session.ratingValue': '{value} sur 5',
  'audit.session.noRating': 'Pas d\'évaluation du client.',
  'audit.session.clientComment': 'Commentaire du client',
  'audit.session.ticket': 'Rapport par ticket',
  'audit.session.ticketDownload': 'Télécharger le rapport (JSON)',
  'audit.session.noTicket': 'Aucun ticket associé à cette session.',
  'audit.rec.title': 'Enregistrement',
  'audit.rec.none': 'Cette session n\'a pas été enregistrée.',
  'audit.rec.consent': 'Consentement du client',
  'audit.rec.consent.granted': 'Accordé',
  'audit.rec.consent.pending': 'En attente',
  'audit.rec.consent.denied': 'Refusé',
  'audit.rec.size': 'Taille',
  'audit.rec.sizeValue': '{size} Mo · {duration}',
  'audit.rec.encryption': 'Chiffrement',
  'audit.rec.encrypted': 'Chiffré au repos',
  'audit.rec.notEncrypted': 'Non chiffré',
  'audit.rec.retention': 'Rétention',
  'audit.rec.retentionUntil': 'Jusqu\'au {date} ({days} jour(s) restants)',
  'audit.rec.purged': 'Purgé le {date} (fin de rétention)',
  'audit.rec.purgedNote': 'L\'enregistrement a été supprimé à l\'issue de la rétention.',
  'audit.rec.pendingNote': 'Lecture verrouillée : le client n\'a pas encore consenti à la relecture.',
  'audit.rec.deniedNote': 'Lecture impossible : le client a refusé la relecture.',
  'audit.rec.play': 'Lire l\'enregistrement',
  'audit.rec.noPermission': 'Permission « enregistrements » requise.',
  'audit.rec.playTitle': 'Lire l\'enregistrement',
  'audit.rec.playDesc': 'La lecture est journalisée dans l\'audit avec votre motif.',
  'audit.rec.reason': 'Motif de la relecture',
  'audit.rec.reasonHint': 'Au moins 5 caractères (ex. litige, ticket, formation).',
  'audit.rec.playConfirm': 'Lire',
  'audit.rec.consentRequired': 'Le client n\'a pas consenti à la relecture.',
  'audit.rec.accessError': 'Accès à l\'enregistrement impossible.',
  'audit.rec.player': 'Lecteur d\'enregistrement',
  'audit.rec.pause': 'Pause',
  'audit.rec.resume': 'Lecture',
  'audit.rec.seek': 'Position de lecture',
  'audit.rec.expires': 'Accès temporaire valable jusqu\'à {time}',
  'audit.compliance.period': 'Période',
  'audit.compliance.lastDays': '{days} derniers jours',
  'audit.compliance.download': 'Télécharger le rapport',
  'audit.compliance.exportEvents': 'Exporter les événements',
  'audit.compliance.access': 'Indicateurs d\'accès',
  'audit.compliance.events': 'Événements audités',
  'audit.compliance.sessionsHint': '{count} session(s) sur la période',
  'audit.compliance.denied': 'Accès refusés',
  'audit.compliance.deniedHint': 'Bloqués par une politique ou un rôle',
  'audit.compliance.failures': 'Échecs',
  'audit.compliance.failedLogins': 'dont {count} connexion(s) échouée(s)',
  'audit.compliance.invalid': 'Signatures invalides',
  'audit.compliance.invalidHint': 'Intégrité du chaînage de hash',
  'audit.compliance.invalidAlert': '{count} événement(s) dont la signature est invalide sur la période : à examiner.',
  'audit.compliance.review': 'Voir les événements',
  'audit.compliance.retention': 'Rétention des données',
  'audit.compliance.retentionDesc': 'Durées de conservation appliquées à votre organisation (réglables dans les paramètres).',
  'audit.compliance.auditRetention': 'Journal d\'audit',
  'audit.compliance.recRetention': 'Enregistrements de sessions',
  'audit.compliance.days': '{days} jours',
  'audit.compliance.integrity': 'Intégrité',
  'audit.compliance.integrityDesc': 'Chaque événement est signé et chaîné ; toute altération est détectée.',
  // <<< zone audit

  // Zone Paramètres
  ...settingsFr,
  ...satisfactionFr,
} as const;

export type TranslationKey = keyof typeof fr;
